<ng-container *ngIf="headerSubheading; then subHeadingLayout; else noSubHeadingLayout" ></ng-container>
<div class='avano-panel-content' [class.avano-panel-collapsed]='collapsed' [class.avano-panel-no-padding]='noPadding'>
  <ng-content></ng-content>
</div>
<div class='avano-panel-footer' *ngIf='footerTemplate' [class.avano-panel-collapsed]='collapsed'>
  <ng-container *ngTemplateOutlet='footerTemplate'></ng-container>
</div>

<!-- Layouts -->
<ng-template #noSubHeadingLayout>
  <div class='avano-panel-header' (click)='collapsePanel()' [class.avano-panel-collapsable]='isCollapsable'>
    <ng-container *ngTemplateOutlet="headerIconContainer"></ng-container>
    <div style="display: flex; flex-wrap: wrap; flex: 1 1 auto">
      <ng-container *ngTemplateOutlet="titleWithActionButtonsContainer"></ng-container>
      <ng-container *ngTemplateOutlet='summaryContainer'></ng-container>
    </div>

    <ng-container *ngTemplateOutlet="areaActionsContainer"></ng-container>
  </div>
</ng-template>

<ng-template #subHeadingLayout>
  <div class='avano-panel-header' (click)='collapsePanel()' [class.avano-panel-collapsable]='isCollapsable'>
    <ng-container *ngTemplateOutlet="headerIconContainer"></ng-container>
    <div class="avano-panel-header-multiline">
      <div>
        <ng-container *ngTemplateOutlet="titleWithActionButtonsContainer"></ng-container>
        <div class='avano-panel-header-spacer'></div>
        <ng-container *ngTemplateOutlet="areaActionsContainer"></ng-container>
      </div>
      <div>
        {{ headerSubheading }}
      </div>
      <ng-container *ngTemplateOutlet='summaryContainer'></ng-container>
    </div>
  </div>
</ng-template>

<!-- Common sub-templates -->
<ng-template #headerIconContainer>
  <i *ngIf='headerIcon' class='avano-panel-header-icon' [ngClass]='headerIcon'></i>
</ng-template>

<ng-template #titleWithActionButtonsContainer>
  <div class="avano-panel-header-caption-and-content-actions">
    <span class='avano-panel-header-heading'>{{ headerText }}</span>
    <div class='avano-panel-header-content-actions' (click)='preventCollapse($event)' *ngIf='contentActionsTemplate || childrenContentActions?.length'>
      <ng-container *ngTemplateOutlet='contentActionsTemplate'></ng-container>
      <i *ngFor="let contentAction of childrenContentActions" 
        [class]="contentAction.icon"
        [title]="contentAction.label"
        [attr.disabled]="contentAction.isDisabled === true"
        (click)="contentAction.action && contentAction.action()"
      ></i>

    </div>
  </div> 
</ng-template>

<ng-template #areaActionsContainer>
  <div class='avano-panel-header-areaactions' (click)='preventCollapse($event)'>
    <ng-container *ngTemplateOutlet='areaActionsTemplate'></ng-container>
    <i *ngIf='isMaximizable' (click)='toggleMaximization()' class='icon-content-maximize-window'></i>
    <i *ngIf='isCollapsable' (click)='collapsePanel()' class='collapseIcon'
      [ngClass]="collapsed ? 'icon-content-chevron-down' : 'icon-content-chevron-up'"></i>
  </div>  
</ng-template>

<ng-template #summaryContainer>
  <div class='avano-panel-header-summary' *ngIf='summaryTemplate'>
    <ng-container *ngTemplateOutlet='summaryTemplate'></ng-container>
  </div>
</ng-template>